import EditAgreement from './EditAgreement';

export default EditAgreement;
